import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LogisticsOrderRequest, LogisticsOrderResponse} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MulesoftService {

  constructor(private httpClient: HttpClient) { }

  private options = {
    headers: new HttpHeaders({
      client_id:  '1944179efd374f2d935b804b530044c7',
      client_secret: 'bE609692401a4293918fBEA40F3dd387'
    })
  };

  sendLogisticsOrder(order: LogisticsOrderRequest): Observable<LogisticsOrderResponse> {
    return this.httpClient.post<LogisticsOrderResponse>(environment.mulesoftApi + 'orders', order, this.options);
  }
}
